import script from "./ViewFileRegisterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewFileRegisterPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewFileRegisterPage.vue?vue&type=style&index=0&id=107d1514&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-107d1514"]])

export default __exports__